// Batch 29 · M70 — while a Save / Cancel bar is on the screen (they stick to the bottom of the page), the floating presence
// widget (bottom-end corner: bottom-right, bottom-left in Arabic) moves up so it never covers the bar's Save button.
import { useEffect, useState } from "react";

let shown = 0;
const listeners = new Set();
const emit = () => listeners.forEach((fn) => { try { fn(shown); } catch (e) { /* a listener never breaks the count */ } });

/** Called by a Save / Cancel bar: counts it as shown while mounted. */
export function useSaveBarPresence() {
  useEffect(() => {
    shown += 1; emit();
    return () => { shown = Math.max(0, shown - 1); emit(); };
  }, []);
}

/** True while at least one Save / Cancel bar is mounted. */
export function useSaveBarShown() {
  const [n, setN] = useState(shown);
  useEffect(() => { listeners.add(setN); setN(shown); return () => { listeners.delete(setN); }; }, []);
  return n > 0;
}

export function _resetSaveBars() { shown = 0; emit(); }   // tests
